import { db } from '../config/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export interface Order {
  id: string;
  orderNumber: string;
  createdAt: string;
  customer?: {
    name: string;
    email?: string;
    phone?: string;
  };
  buyerName: string;
  shippingAddress?: {
    address: string;
    city: string;
    postalCode: string;
    country: string;
  };
  items: {
    id: string;
    name: string;
    sku?: string;
    mainImage?: string;
    quantity: number;
    price: number;
    total: number;
  }[];
  subtotal: number;
  shippingCost: number;
  total: number;
  commission?: number;
  status: string;
}

export async function getOrderById(orderId: string): Promise<Order> {
  try {
    const orderRef = doc(db, 'orders', orderId);
    const orderSnap = await getDoc(orderRef);

    if (!orderSnap.exists()) {
      throw new Error('Order not found');
    }

    const orderData = orderSnap.data();
    return {
      id: orderSnap.id,
      ...orderData,
    } as Order;
  } catch (error) {
    console.error('Error getting order:', error);
    throw error;
  }
}

export async function updateOrder(orderId: string, data: Partial<Order>): Promise<void> {
  try {
    const orderRef = doc(db, 'orders', orderId);
    await updateDoc(orderRef, data);
  } catch (error) {
    console.error('Error updating order:', error);
    throw error;
  }
}
